/*
 * Advanced Filters  Messages
 *
 * This contains all the text for the Advanced Filters component.
 */

import { defineMessages } from 'react-intl';
export const scope = 'src.components.AdvancedFilters';

export default defineMessages({
  filterNameLabel: {
    id: `${scope}.filterNameLabel`,
    defaultMessage: 'Field',
  },
  filterOperatorLabel: {
    id: `${scope}.filterOperatorLabel`,
    defaultMessage: 'Operator',
  },
  filterValueLabel: {
    id: `${scope}.filterValueLabel`,
    defaultMessage: 'Value',
  },
  addFilterButton: {
    id: `${scope}.addFilterButton`,
    defaultMessage: 'Add filter',
  },
  clearFiltersButton: {
    id: `${scope}.clearFiltersButton`,
    defaultMessage: 'Clear All',
  },
  searchButton: {
    id: `${scope}.searchButton`,
    defaultMessage: 'Search',
  },
});
